import styles from "./register-presentation.module.css";
import ranaWelcome from "illustrations/rana/rana-welcome.webp";
import { useTranslation } from "react-i18next";

const RegisterPresentation = () => {
  const { t } = useTranslation();

  return (
    <section className={styles["register-design"]}>
      <div className={styles["illustration-container"]}>
        <h2 className="title-2">
          {t("register.role-step.illustration.title")}
        </h2>
        <img
          className={styles["illustration-image"]}
          src={ranaWelcome}
          alt=""
        />
        <div className={styles["illustration-description"]}>
          <h3 className="subtitle-2-variant-low">
            {t("register.role-step.illustration.partners.title")}
          </h3>
          <div className={styles.partners}>
            <p className="title-2">Blablacar</p>
            <p className="title-2">Ankorstore</p>
            <p className="title-2">Dataiku</p>
            <p className="title-2">Accenture</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegisterPresentation;
